import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import {
  ActivatedRoute,
} from '@angular/router';
import { Dataset } from 'src/app/model/dataset/dataset';
import { EndpointConfig } from 'src/app/config/endpoint-config';
import { DialogService } from 'src/app/service/dialog-service';
import { WebDataApiService } from 'src/app/service/server/web-data-api-service';
import { CommonUtils } from 'src/app/utils/common';
import { finalize, mergeMap } from 'rxjs/operators';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { AuthenticatedImagePipe } from 'src/app/pipe/authenticated-image';



@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.css']
})
export class ImageViewComponent implements OnInit, OnDestroy {

  private projectName: string | null = null;
  private datasetId: string | null = null;
  private dataset: Dataset | null = null;
  private documentId: string | null = null;
  private size: string | null = null;
  private imageSrc: string | null = null;

  // viewer用変数
  scale = 1;
  initialScale = 1;
  translateX = 0;
  translateY = 0;
  isLoaded = false;

  // ドラッグ移動用
  private isDragging = false;
  private startX = 0;
  private startY = 0;


  constructor(
    private activatedRoute: ActivatedRoute,
    private endpointConfig: EndpointConfig,
    private http: HttpClient,
    private dialog: DialogService,
    private webDataApiService: WebDataApiService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.dialog.loadingShow()
    this.projectName = this.activatedRoute.snapshot.paramMap.get('projectName');
    this.datasetId = this.activatedRoute.snapshot.paramMap.get('datasetId');
    this.size = this.activatedRoute.snapshot.queryParams.size;


    let url = this.endpointConfig.riaApi.project.dataset.getUrl(this.projectName, this.datasetId);
    this.http.get<Dataset>(url).pipe(
      mergeMap(dataset => {
        this.dataset = dataset;
        console.log("dataset", dataset)
        this.documentId = this.dataset.zoomSrc.split('?')[0].split('/').slice(-1)[0];
        let collectionPath = CommonUtils.getUDPImageCollectionPath(this.dataset.zoomSrc);
        let params = new HttpParams().set('collectionPath', collectionPath).set('size', this.size)
        return this.webDataApiService.getUDPImageInfo([this.documentId], { params: params })
      }),
      finalize(() => this.dialog.loadingHide())
    ).subscribe((udpImageResponse) => {
      let signedUrlData = udpImageResponse.signedUrls[0]
      this.imageSrc = this.endpointConfig.riaApi.webData.udp.signedImage.getUrl(signedUrlData.signedUrl)
    })
  };

  // ホイールで拡大縮小
  onWheel(event: WheelEvent) {
    event.preventDefault();
    const zoomStep = 0.1;
    if (event.deltaY < 0) {
      this.scale += zoomStep;
    } else {
      const nextScale = this.scale - zoomStep;
      // 計算したスケールが初期サイズ(全体表示)以下になる場合
      if (nextScale <= this.initialScale) {
        this.scale = this.initialScale; // 初期サイズにリセット
        this.translateX = 0; // 画像を中央に配置
        this.translateY = 0; // 画像を中央に配置
      } else {
        this.scale = nextScale; // 通常の縮小処理
      }
    }
  }

  // ドラッグで移動
  onMouseDown(event: MouseEvent) {
    event.preventDefault();
    this.isDragging = true;
    this.startX = event.clientX - this.translateX;
    this.startY = event.clientY - this.translateY;

    const onMouseMove = (moveEvent: MouseEvent) => {
      if (!this.isDragging) return;
      this.translateX = moveEvent.clientX - this.startX;
      this.translateY = moveEvent.clientY - this.startY;
    };

    const onMouseUp = () => {
      this.isDragging = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }

  getTransform(): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(`translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`);
  }

  onLoad(event: Event) {
    this.isLoaded = true;
    const img = event.target as HTMLImageElement;
    // 画像の自然な幅と高さを取得して、ビューアのサイズを調整する
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    const containerWidth = window.innerWidth;
    const containerHeight = window.innerHeight;

    // 画像がコンテナに収まるように初期スケールを計算
    const widthRatio = containerWidth / naturalWidth * 0.9; // 少し余白を持たせる
    const heightRatio = containerHeight / naturalHeight * 0.9; // 少し余白を持たせる
    this.initialScale = Math.min(widthRatio, heightRatio, 1); // 元画像以上に大きくならないようにする
    this.scale = this.initialScale;

    // 画像をコンテナの中央に配置
    this.translateX = 0;
    this.translateY = 0;
  }

  reset() {
    this.scale = this.initialScale;
    this.translateX = 0;
    this.translateY = 0;
  }

  ngOnDestroy() {
    AuthenticatedImagePipe.clearCache();
  }
}